module.exports = __webpack_public_path__ + "static/media/jsImg8.5cb08591.png";